// extracted by mini-css-extract-plugin
export default {"price-type-info-icon":"PriceTypeFilter_price-type-info-icon__BNtpp"};